import React, { useEffect, useRef, useState } from 'react';
import { IconButton } from '../../../IconButton';
import { ConfigurableFloatingMenu } from '../../../FloatingMenu/FloatingMenu';
import styles from './MoreButton.scss';

export const MoreButton: React.FC<{ onOptionSelect: (val: string) => void }> = ({ onOptionSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const moreOnClick = () => {
    setIsOpen(true);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  useEffect(() => {
    const handleEscapeKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscapeKey);
    }

    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [isOpen]);

  return (
    <div ref={containerRef} className={styles.moreButtonContainer__Wrapper}>
      <IconButton
        datatestid="settings-button"
        arialabel="open settings"
        onClick={moreOnClick}
        name="more"
        size="md"
        className={styles.moreButtonContainer__Button}
      />
      <ConfigurableFloatingMenu
        isMenuOpen={isOpen}
        menuDirection="up"
        menuAlignment="left"
        onOptionSelect={onOptionSelect}
        options={[{ label: 'Settings', value: 'settings' }]}
        testId="more-button-floating-menu"
        role="menu"
      />
    </div>
  );
};
